import api from "../api/axios";

const expenseCategoryService = {
  getAll: () => api.get("/expensecategory/get-all"),
  getById: (id) => api.get(`/expensecategory/get/${id}`),
  create: (data) => api.post("/expensecategory/create", data),
  update: (data) => api.post("/expensecategory/update", data),
  delete: (id) => api.delete(`/expensecategory/delete/${id}`),
};

export default expenseCategoryService;
